import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import UserListTable from './Users';
const UserList = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='User List' parent='user List'  />
      <Container fluid={true}>
        <Row>
          <UserListTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default UserList;
